import type { GetSelectedThoughtDocumentsRequest } from "../api/getSelectedThoughtDocuments";

function serializeSelectedThoughts(
  selectedThoughts: GetSelectedThoughtDocumentsRequest["selectedThoughts"],
) {
  return selectedThoughts.map((selection) => ({
    prototype: selection.prototype,
    situation_id: selection.situation_id,
    thoughts_ids: selection.thoughts_ids,
  }));
}

export const studioKeys = {
  needsAnchorCount: (
    validSituationIds: string[],
    refreshStamp: { confirmed: string },
  ) =>
    [
      "studio",
      "needs-anchor-count",
      {
        validSituationIds,
        refreshStamp,
      },
    ] as const,
  selectedThoughtRerank: (
    request: GetSelectedThoughtDocumentsRequest,
    rerankQuery: string,
    meiliRefreshStamp = 0,
  ) =>
    [
      "studio",
      "selected-thought-rerank",
      {
        selectedThoughts: serializeSelectedThoughts(request.selectedThoughts),
        rerankQuery,
        meiliRefreshStamp,
      },
    ] as const,
};
